import { Component, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';
import { SimplifiedTarget } from '@schoolbelle/api/letter-target';
import { GroupService } from '@schoolbelle/api/group';
import { GroupMember } from '@schoolbelle/api/group-member';



@Component({
  selector: 'app-select-letter-targets',
  templateUrl: './select-letter-targets.component.html',
  styleUrls: ['./select-letter-targets.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectLetterTargetsComponent {
  @Input() tab:'studentparent'|'faculty' = 'studentparent';
  studentparent_checked_cnt:number = 0;
  faculty_checked_cnt:number = 0;
  simplifiedTargets:SimplifiedTarget[] = [];
  constructor (
    private group:GroupService,
  ) {
  }



  get checked_cnt () {
    return this.studentparent_checked_cnt + this.faculty_checked_cnt;
  }
  hasAccessToMemberlist:boolean = false; 
  ngOnInit () {
    this.hasAccessToMemberlist = this.group.checkPermission('admin')  || this.group.checkPermission('faculty')  
  }

  goToMember (member:GroupMember) {

  }
}
